/**
 * Download Url element
 */
export function downloadUrl(url, label) {
  const xhr = new XMLHttpRequest();
  // convert url to blob and simulate click
  xhr.onload = () => {
    const blob = new Blob([xhr.response], { type: "image/jpg" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${label.replace(/\s/g, "")}.jpg`;
    setTimeout(() => {
      URL.revokeObjectURL(link.href);
    }, 4e4);
    setTimeout(() => {
      link.click();
    }, 0);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
}



// WEBPACK FOOTER //
// ./src/helpers/downloadUrl.ts